import styled from 'styled-components';

import { DSTokenMap } from '@rover/kibble/styles';

export const UL = styled.ul`
  max-width: 640px;
  margin-bottom: ${DSTokenMap.SPACE_8X};
`;
export const OL = styled.ol`
  max-width: 640px;
  margin-bottom: ${DSTokenMap.SPACE_8X};
`;
export const LI = styled.li`
  padding: ${DSTokenMap.SPACE_1X} 0;
  font-size: ${DSTokenMap.PARAGRAPH_200_FONT_SIZE};
  line-height: ${DSTokenMap.PARAGRAPH_200_LINE_HEIGHT};

  :not(:last-child) {
    margin-bottom: ${DSTokenMap.SPACE_2X};
  }
`;
export default {
  UL,
  OL,
  LI,
};
